// Android Chrome sends the same utterance several times as it grows
// ("11", "11", "11 hiányzik"). This classifies each final result against the
// previous one so the caller can drop repeats and handle growth.

const WINDOW_MS = 2500;

const normalise = (s: string) => s.toLowerCase().replace(/\s+/g, ' ').trim();

export type FinalResult =
  | { kind: 'repeat' }
  | { kind: 'new'; text: string }
  /** The previous result plus more words; `added` is only the new part. */
  | { kind: 'extends'; text: string; added: string };

export type FinalFilter = (text: string, now?: number) => FinalResult;

export function createFinalFilter(windowMs = WINDOW_MS): FinalFilter {
  let last = '';
  let lastAt = -Infinity;
  return (raw, now = Date.now()) => {
    const text = raw.trim();
    const current = normalise(text);
    if (!current) return { kind: 'repeat' };
    const recent = now - lastAt < windowMs;
    const previous = last;
    last = current;
    lastAt = now;
    if (!(recent && previous)) return { kind: 'new', text };
    if (current === previous) return { kind: 'repeat' };
    if (current.startsWith(`${previous} `)) {
      const added = text.split(/\s+/).slice(previous.split(' ').length).join(' ');
      return { kind: 'extends', text, added };
    }
    return { kind: 'new', text };
  };
}
